import HolidayList from "@/controllers/holiday/holiday-list";
import CONFIG from "@/assets/js/config.custom.js";
import axios from "axios";
import Select2Multiple from 'v-select2-multiple-component';

export default {
  extends: HolidayList,
  components: {
    Select2Multiple
  },
  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_EXIST,
      selectedCategory: '',
      selectedType: '',
      typeList: Object.entries(CONFIG.HOLIDAY_TYPE_OPTIONS).map(([id, text]) => ({
        id,
        text
      })),
      categoryList: CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS.map(item => ({
        id: item.id,
        text: item.label,
      })),
      templateLink: '',
      holidayFile: '',
      holidayFileName: '',
      invalidFileType: false,
      disabled: false,
      submitted: false,
    };
  },
  mounted() {
    if (this.can('Holiday', 'importExcel')) this.getTemplateLink();
    
  },
  methods: {
    holidayCategoryLabel(row) {
      const id = row.category_id;
      if (id === null || id === undefined || id === "") {
        return "—";
      }
      const catId = Number(id);
      if (Number.isNaN(catId)) {
        return "—";
      }
      const cats = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
      const cat = cats.find((c) => Number(c.id) === catId);
      return cat ? cat.label : "—";
    },

    holidayCategoryColor(row) {
      const id = row.category_id;
      if (id === null || id === undefined || id === "") {
        return null;
      }
      const catId = Number(id);
      if (Number.isNaN(catId)) {
        return null;
      }
      const cats = CONFIG.HOLIDAY_EVENT_CATEGORY_OPTIONS || [];
      const cat = cats.find((c) => Number(c.id) === catId);
      return cat ? cat.color_code : null;
    },

    holidayTypeLabel(row) {
      const t = row.type;
      if (t === null || t === undefined || t === "") {
        return "—";
      }
      const opts = CONFIG.HOLIDAY_TYPE_OPTIONS || {};
      const num = Number(t);
      if (!Number.isNaN(num) && opts[num] !== undefined) {
        return opts[num];
      }
      if (opts[t] !== undefined) {
        console.log("opts[t]", opts[t]);
        return opts[t];
      }
      return "—";
    },

    searchHoliday(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      this.searchedData = {
        month: this.month,
        category_id: this.selectedCategory,
        type: this.selectedType
      };
      this.isSearched = true;
      axios.get('holiday/search?page=' + page, {
        params: {
          month: this.month,
          category_id: this.selectedCategory,
          type: this.selectedType,
        }
      })
        .then(res => {
          if (res.data) {
            this.holidayMasterData = res.data;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    reset() {
      this.month = null;
      this.selectedMonth = null;
      this.selectedCategory = null;
      this.selectedType = null;
      this.isLoading = true;
      this.getAllHoliday();
      this.isSearched = false;
    },

    downloadSchoolCalendar() {
      this.isLoading = true;
      axios.get('/holiday/download-school-calendar', {
        responseType: 'blob',
        headers: {
          'Accept': 'application/pdf'
        }
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          // school_calendar_current_yyyy_mm_dd_tuition_plan.pdf
          const fileName = `school_calendar_current_${date.getFullYear()}_${(date.getMonth() + 1).toString().padStart(2, '0')}_${date.getDate().toString().padStart(2, '0')}.pdf`;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.error("Download failed:", error);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData, category_id: this.selectedCategory, type: this.selectedType, search_status: this.search_status }
        : { acd_year_start_date: this.currentAcdYear.start_date ?? null, acd_year_end_date: this.currentAcdYear.end_date ?? null, category_id: this.selectedCategory, type: this.selectedType, search_status: this.search_status };
      axios.get('/holiday/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `holiday_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    getAllHoliday(page = 1) {
      axios.get('holiday/list?page=' + page, {
        params: {
          acd_year_start_date: this.currentAcdYear.start_date ?? null,
          acd_year_end_date: this.currentAcdYear.end_date ?? null,
        }
      }).then((response) => {
        this.holidayMasterData = response.data;
        this.isLoading = false;
      }).catch((error) => {
        if (error.response?.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
        console.error('Error in getAllHoliday:', error);
      });
    },

    getTemplateLink() {
      axios.get('holiday/getTemplateLink')
        .then(res => {
          this.templateLink = res.data;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    chooseFile() {
      this.$refs.fileUploader.value = '';
      document.getElementById('holiday-upload').click();
    },

    onHolidayFileChange() {
      this.invalidFileType = false;
      let selectedFile = document.getElementById('holiday-upload').files;
      if (selectedFile.length) {
        let file = selectedFile[0];
        if (file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.holidayFileName = file.name;
          this.holidayFile = file;
        } else {
          this.invalidFileType = true;
        }
      }
      this.disabled = false;
    },

    clearFile() {
      this.holidayFile = '';
      this.holidayFileName = '';
      this.invalidFileType = false;
      this.disabled = false;
      this.submitted = false;
      if (this.$refs.fileUploader) {
        this.$refs.fileUploader.value = '';
      }
    },

    importFile() {
      this.submitted = true;
      this.disabled = false;

      if (!this.holidayFile) {
        this.disabled = false;
        return;
      }

      this.isLoading = true;
      let data = new FormData();
      data.append('holiday_xlsx', this.holidayFile);

      axios.post("holiday/import", data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(response => {
        if (response.data.success == true) {
          this.$notification.success(response.data.msg, {
            timer: 3,
            position: "bottomCenter"
          });
          this.disabled = false;
          this.clearFile();
          this.getAllHoliday();
        } else {
          this.isLoading = false;
          this.disabled = false;
          this.clearFile();
          alert(response.data.msg);
        }
      }).catch(error => {
        this.isLoading = false;
        this.disabled = false;
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error('Error in import holiday:', error);
      });
    },
  },
};
